import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { FirewallRule, RulePosition } from '../../@types/firewall-rule';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

interface Vars {
    id: number;
    body: FirewallRule & RulePosition;
}

export function useUpdateFirewallRuleMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, body }: Vars) => Endpoints.v1.Firewalls.VMRules.updateRule(id, body),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ['api.v1.firewalls.vm-rules', variables.id],
            });
            notifications.show({
                title: t('firewall.ruleUpdatedTitle'),
                message: t('firewall.ruleUpdatedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('firewall.ruleUpdateFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
